import { View, Text, SafeAreaView } from "react-native";

export default function Search() {
  return <Text className="text-text-primary">Search</Text>;
}
